import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Moment from "react-moment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import GetAppRoundedIcon from "@mui/icons-material/GetAppRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import Tooltip from "@mui/material/Tooltip";
import HomeIcon from "@mui/icons-material/Home";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";

function GARFOList({ vtrs, editClick, pdfHandler, auth }) {
  const [page, setPage] = useState(0);
  const [tripsPerPage] = useState(8);
  const navigate = useNavigate();
  const permitsObj = useSelector((state) => state.validation.validations.permit);

  const getVesselName = (permitNbr) => {
    const vessel =
      Number(permitNbr) === 555555
        ? { VES_NAME: "Substainable Catch" }
        : permitsObj.find(({ PNUM }) => Number(PNUM) === Number(permitNbr));

    if (!vessel) {
      return "Unknown Vessel Name";
    }
    return vessel.VES_NAME;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleClick = (event) => {
    event.preventDefault();
    navigate(`${process.env.PUBLIC_URL}/home`, {
      state: { ...auth },
    });
  };

  return (
    <Paper
      sx={{
        width: "100%",
      }}
    >
      <TableContainer sx={{ maxHeight: 540 }}>
        <Table stickyHeader arial-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                <Tooltip title="Home Screen">
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={(event) => handleClick(event)}
                  >
                    <HomeIcon />
                  </Button>
                </Tooltip>
              </TableCell>
              <TableCell align="center" colSpan={5}>
                <Typography variant="h5" gutterBottom>
                  Trips List
                </Typography>
              </TableCell>
              <TableCell />
            </TableRow>
            <TableRow>
              <TableCell>Trip</TableCell>
              <TableCell>Date Sailed</TableCell>
              <TableCell>Date Landed</TableCell>
              <TableCell>Vessel</TableCell>
              <TableCell>Download PDF</TableCell>
              <TableCell>View PDF</TableCell>
              <TableCell>Edit Trip</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vtrs
              .slice(page * tripsPerPage, page * tripsPerPage + tripsPerPage)
              .map((vtr, idx) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={idx}>
                    <TableCell component="th" scope="row" key={`fist_${idx}`}>
                      {vtr.SUBMISSION_TYPE.toUpperCase() === "PAPER"
                        ? vtr.LOWEST_SERIAL_NUM
                        : vtr.TRIP_ID}
                    </TableCell>
                    <TableCell>
                      <Moment parse={"YYMMDD LT"} format={"DD-MMM-YY LT"}>
                        {vtr.DATE_SAIL}
                      </Moment>
                    </TableCell>
                    <TableCell>
                      <Moment parse={"YYMMDD LT"} format={"DD-MMM-YY LT"}>
                        {vtr.DATE_LAND}
                      </Moment>
                    </TableCell>
                    <TableCell>{`${vtr.VESSEL_PERMIT_NUM} - ${getVesselName(
                      vtr.VESSEL_PERMIT_NUM
                    )}`}</TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        key={"pdf_save_" + vtr.TRIP_ID}
                        data-trip-id={vtr.TRIP_ID}
                        startIcon={<GetAppRoundedIcon />}
                        onClick={pdfHandler("save")}
                      />
                    </TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        key={`pdf_view_${vtr.TRIP_ID}`}
                        data-trip-id={vtr.TRIP_ID}
                        startIcon={<VisibilityRoundedIcon />}
                        onClick={pdfHandler("view")}
                      />
                    </TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        key={"edit_" + vtr.TRIP_ID}
                        data-trip-id={vtr.TRIP_ID}
                        startIcon={<EditRoundedIcon />}
                        onClick={editClick}
                        disabled={vtr.IS_LOCKED === "1"}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[tripsPerPage]}
        component="div"
        count={vtrs.length}
        rowsPerPage={tripsPerPage}
        page={page}
        onPageChange={handleChangePage}
      />
    </Paper>
  );
}

export default GARFOList;
